import axios from 'axios';
import { getStorageItem, removeStorageItem, STORAGE_KEYS } from '@/management/storage';
// Base URL for the Laravel API
// You can change this based on your environment
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://api.pellle.com/api';
// Create axios instance for management API
const managementApi = axios.create({
    baseURL: `${API_BASE_URL}/management`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    timeout: 30000, // 30 seconds timeout
    withCredentials: false // Don't send cookies with cross-origin requests
});
// Request interceptor to add auth token
managementApi.interceptors.request.use((config) => {
    // Get token from localStorage
    const token = getStorageItem(STORAGE_KEYS.AUTH_TOKEN);
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // If data is FormData, remove Content-Type header to let browser set it with boundary
    if (config.data instanceof FormData && config.headers) {
        delete config.headers['Content-Type'];
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Response interceptor for error handling
managementApi.interceptors.response.use((response) => {
    return response;
}, (error) => {
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response?.status === 401) {
        // Clear token and redirect to login
        // You can customize this based on your needs
        removeStorageItem(STORAGE_KEYS.AUTH_TOKEN);
        // Optionally redirect to login page
        // window.location.href = '/management/login'
    }
    return Promise.reject(error);
});
export default managementApi;
